<template>
  <div class="w-100">
    <div
      v-if="$route.name !== 'round-detail-matches' && round.matches.length"
      :class="$style.matchesLinkWrapper"
    >
      <b-container>
        <b-row class="py-3 px-2">
          <b-col class="pl-0">
            {{ $tc('x-matches', round.matches.length, { matchesCount: round.matches.length }) }}
          </b-col>
          <b-col class="text-right pr-0">
            <router-link :to="{name: 'round-detail-matches', params: { roundId: round.id }}">
              {{ $t('see-details') }}
              <font-awesome-icon icon="angle-right" />
            </router-link>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <template v-if="$route.name === 'round-detail-matches'">
      <BaseTextH1 has-wrapper>
        {{ $t('MATCHES') }}
      </BaseTextH1>

      <div class="clear-both" />
      <TheMatchDetailRow
        v-for="match in round.matches"
        :key="match.id"
        :match="match"
        no-hover
        no-match-detail
      />
    </template>
    <MyTeamUpcoming
      v-else-if="round.status === roundStatuses.upcoming"
      :round-id="round.id"
      :round="round"
      :is-athlete-assignment-processing="isAthleteAssignmentProcessing"
      :selected-athletes="selectedAthletes"
      @onAthletePick="(params) => $emit('onAthletePick', params)"
      @onAthletePickRemove="(params) => $emit('onAthletePickRemove', params)"
    />
    <MyTeamClosedAndLive
      v-else-if="round.status === roundStatuses.live || round.status === roundStatuses.closed"
      :class="$style.wrapper"
      :athletes="selectedAthletes"
    />
  </div>
</template>

<script>
import BaseTextH1 from '@/components/Atoms/Typography/BaseTextH1'
import TheMatchDetailRow from '@/components/Molecules/TheMatchDetailRow'
import MyTeamUpcoming from '@/pages/Home/Components/MyTeamUpcoming'
import MyTeamClosedAndLive from '@/pages/Home/Components/MyTeamClosedAndLive'

export default {
  name: 'RoundDetailClassic',
  components: {
    MyTeamClosedAndLive,
    MyTeamUpcoming,
    TheMatchDetailRow,
    BaseTextH1,
  },
  props: {
    round: {
      type: Object,
      default: () => {},
    },
    roundStatuses: {
      type: Object,
      default: () => {},
    },
    selectedAthletes: {
      type: Array,
      default: () => [],
    },
    isAthleteAssignmentProcessing: {
      type: Number,
      required: false,
      default: null,
    },
  },
}
</script>

<style module lang="scss">
  @import "../../../../assets/scss/variables";
  .wrapper {
    background-color: $color-bleached-silk;
  }
  .matchesLinkWrapper {
    background-color: $color-bleached-silk;
    border-bottom: 1px solid $color-jupiter;
  }
</style>
